import TransparentTextField from "../../TransparentTextField/TransparentTextField";
import { useEffect, useState } from "react";
import styles from "../Drawer.module.scss";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";

function PayCustomAmount() {
  const [customAmount, setCustomAmount] = useState("");
  const { setVenuesData } = useVenuesDataStore();

  useEffect(() => {
    setVenuesData({ selectedAmount: 0, splitMethod: "custom" });
  }, [setVenuesData]);

  useEffect(() => {
    const parsed = parseFloat(customAmount);
    setVenuesData({ selectedAmount: isNaN(parsed) ? 0 : parsed });
  }, [customAmount, setVenuesData]);

  return (
    <div className={styles.customAmountContent}>
      <TransparentTextField value={customAmount} setValue={setCustomAmount} />
    </div>
  );
}

export default PayCustomAmount;
